import { render, staticRenderFns } from "./MAN936M04.vue?vue&type=template&id=bb0c3b36&"
import script from "./MAN936M04.vue?vue&type=script&lang=js&"
export * from "./MAN936M04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports